import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealsStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/deals-standard-quote-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';


@Component({
  selector: 'app-deals-standard-quote-mobile',
  templateUrl: './deals-standard-quote-mobile.component.html',
  styleUrls: ['./deals-standard-quote-mobile.component.scss'],
})
export class DealsStandardQuoteMobileComponent extends DealsStandardQuoteWrapperComponent {
  constructor(route: ActivatedRoute, menu: MenusServices, notification: NotificationService) {
    super(route, menu, notification);
  }
}
